import * as Yup from 'yup';

const INITIAL_VALUES = {
    acknowledgeName: '',
    acknowledgeCheckBox: false
};

const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
        acknowledgeName: Yup.string().trim().required('Name is required.'),
    }

    return Yup.object().shape(schemaAttributes);
}

export { INITIAL_VALUES, VALIDATION_SCHEMA };
